import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const tipLabel = { faturali_vet: 'Faturalı Vet', faturasiz_vet: 'Faturasız Vet', klinik: 'Vet. Hekim', bireysel: 'Bireysel', bayi: 'Bayi', diger: 'Diğer' };

export default function MusteriDetay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [musteri, setMusteri] = useState(null);
  const [siparisler, setSiparisler] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ toplam: 0, odenmis: 0, odenmemis: 0, adet: 0 });

  useEffect(() => { fetchData(); }, [id]);

  async function fetchData() {
    const [{ data: m }, { data: s }] = await Promise.all([
      supabase.from('musteriler').select('*, kullanicilar(ad, soyad)').eq('id', id).single(),
      supabase.from('siparisler').select('*, firmalar(ad)').eq('musteri_id', id).order('created_at', { ascending: false }),
    ]);
    setMusteri(m);
    setSiparisler(s || []);
    const toplam = (s || []).reduce((a, r) => a + (r.toplam_tutar || 0), 0);
    const odenmis = (s || []).filter(r => r.odeme_durumu === 'odendi').reduce((a, r) => a + (r.toplam_tutar || 0), 0);
    setStats({ toplam, odenmis, odenmemis: toplam - odenmis, adet: (s || []).length });
    setLoading(false);
  }

  if (loading) return <div className="loading">Yükleniyor...</div>;
  if (!musteri) return <div className="empty">Müşteri bulunamadı</div>;

  const fmt = v => (v || 0).toLocaleString('tr-TR');

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/musteriler')} style={{ marginBottom: 8 }}>← Müşteriler</button>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <h1 style={{ fontSize: 18, fontWeight: 700, margin: 0 }}>{musteri.ad}</h1>
            <p style={{ fontSize: 12, color: 'var(--text2)', margin: 0 }}>{tipLabel[musteri.musteri_tipi]} • {musteri.sehir}</p>
          </div>
          <button className="btn btn-primary btn-sm" onClick={() => navigate('/siparisler/yeni')}>+ Sipariş</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 12 }}>
        <div className="stat-card"><div className="stat-label">Toplam Sipariş</div><div className="stat-value">{stats.adet}</div></div>
        <div className="stat-card"><div className="stat-label">Toplam Tutar</div><div className="stat-value" style={{ fontSize: 15 }}>{fmt(stats.toplam)} ₺</div></div>
        <div className="stat-card"><div className="stat-label">Ödenen</div><div className="stat-value" style={{ fontSize: 15, color: 'var(--green)' }}>{fmt(stats.odenmis)} ₺</div></div>
        <div className="stat-card"><div className="stat-label">Bekleyen</div><div className="stat-value" style={{ fontSize: 15, color: 'var(--red)' }}>{fmt(stats.odenmemis)} ₺</div></div>
      </div>

      <div className="card" style={{ marginBottom: 12 }}>
        <h3 style={{ marginBottom: 12, fontWeight: 700, fontSize: 14 }}>Müşteri Bilgileri</h3>
        {[
          ['Telefon', musteri.telefon],
          ['E-posta', musteri.email],
          ['Şehir', musteri.sehir],
          ['İlçe', musteri.ilce],
          ['Bölge', musteri.bolge],
          ['Vergi No', musteri.vergi_no],
          ['Temsilci', musteri.kullanicilar ? `${musteri.kullanicilar.ad} ${musteri.kullanicilar.soyad}` : null],
          ['Adres', musteri.adres],
        ].filter(([, v]) => v).map(([k, v]) => (
          <div key={k} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid var(--border)' }}>
            <span style={{ color: 'var(--text2)', fontSize: 12 }}>{k}</span>
            <span style={{ fontSize: 13, fontWeight: 500, maxWidth: '60%', textAlign: 'right' }}>{v}</span>
          </div>
        ))}
      </div>

      <div>
        <h3 style={{ marginBottom: 10, fontWeight: 700, fontSize: 14 }}>Sipariş Geçmişi ({siparisler.length})</h3>
        {siparisler.length === 0
          ? <div style={{ textAlign: 'center', padding: 30, color: 'var(--text2)' }}>Sipariş yok</div>
          : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {siparisler.map(s => (
                <div key={s.id} onClick={() => navigate(`/siparisler/${s.id}`)} style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 'var(--r)', padding: 12, cursor: 'pointer' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <span className="mono" style={{ color: 'var(--accent)', fontWeight: 700 }}>{s.siparis_no}</span>
                    <span style={{ fontSize: 12, color: 'var(--text2)' }}>{new Date(s.created_at).toLocaleDateString('tr-TR')}</span>
                  </div>
                  <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 4 }}>{s.firmalar?.ad}</div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 700, fontSize: 15 }}>{fmt(s.toplam_tutar)} ₺</span>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <span className="badge badge-blue" style={{ fontSize: 10 }}>{s.siparis_durumu}</span>
                      <span className={`badge ${s.odeme_durumu === 'odendi' ? 'badge-green' : 'badge-red'}`} style={{ fontSize: 10 }}>{s.odeme_durumu === 'odendi' ? 'Ödendi' : 'Ödenmedi'}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
      </div>
    </div>
  );
}
